import React from "react";

import { useAppSelector } from "../../../app/hooks";
import LegacyPartyCard from "./LegacyPartyCard";
import { isCreditAccountStakeholdersRevampEnabled } from "../../configs/logic/Slice";
import PartyCard from "./PartyCard";



const PartyCardContainer: React.FC = () => {
  const isRevampEnabled = useAppSelector(
    isCreditAccountStakeholdersRevampEnabled
  );

  return isRevampEnabled ? <PartyCard /> : <LegacyPartyCard />;
};

export default PartyCardContainer;